import React from 'react';
import classNames from 'classnames';
import styles from './ArticleLayoutChrome.module.scss';

type DivProps = React.ComponentPropsWithoutRef<'div'>;

export const ArticleContentWrapper = ({ children, className, ...rest }: DivProps) => (
  <div className={classNames(styles.contentWrapper, className)} {...rest}>
    {children}
  </div>
);

export const ArticleLayoutWrapper = ({ children, className, ...rest }: DivProps) => (
  <div className={classNames(styles.layoutWrapper, className)} {...rest}>
    {children}
  </div>
);
